module.exports = __webpack_public_path__ + "static/img/11.366adbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/11.png
// module id = Q2Xj
// module chunks = 0